import React from 'react';
import { Server } from 'lucide-react';

interface RackPositionMiniMapProps {
  totalU?: number;
  uPosition: number;
  uHeight: number;
  equipmentName: string;
  rackName?: string;
}

export const RackPositionMiniMap: React.FC<RackPositionMiniMapProps> = ({
  totalU = 42,
  uPosition,
  uHeight,
  equipmentName,
  rackName = 'Стойка'
}) => {
  const slots = Array.from({ length: totalU }, (_, i) => totalU - i);
  const startU = uPosition;
  const endU = uPosition + uHeight - 1;

  return (
    <div className="bg-slate-900 border border-slate-800/50 rounded-xl p-4 flex flex-col gap-3 shadow-sm">
      <div className="flex items-center justify-between border-b border-slate-800/20 pb-2">
        <div className="flex items-center gap-2">
          <Server className="w-4 h-4 text-cyan-400" />
          <span className="text-xs font-mono font-bold text-slate-100 uppercase tracking-wider">{rackName}</span>
        </div>
        <span className="text-[10px] font-mono px-2 py-0.5 rounded bg-cyan-950/20 border border-cyan-800/50 text-cyan-450">
          U{uPosition}{uHeight > 1 ? `-U${endU}` : ''} ({uHeight}U)
        </span>
      </div>

      <div className="relative w-full bg-slate-950/40 border border-slate-800/40 rounded-lg p-2 flex flex-col gap-0.5 max-h-[320px] overflow-y-auto custom-scrollbar shadow-inner">
        {slots.map((u) => {
          const isSelected = u >= startU && u <= endU;
          const isTopSlot = u === endU;

          return (
            <div
              key={u}
              className={`h-5 w-full flex items-center justify-between px-2 text-[9px] font-mono rounded transition-colors duration-200 select-none
                ${isSelected
                  ? 'bg-cyan-950/20 border border-cyan-500/80 text-cyan-400 shadow-[0_0_8px_rgba(6,182,212,0.3)] animate-pulse'
                  : 'bg-slate-900/40 border border-slate-800/20 text-slate-500 hover:bg-slate-800/20'
                }`}
            >
              <span className="font-bold w-5 text-left">{u}U</span>
              <span className="truncate max-w-[140px] text-right font-medium">
                {isSelected ? (isTopSlot ? equipmentName : '▲') : ''}
              </span>
            </div>
          );
        })}
      </div>

      <div className="flex items-center justify-between text-[10px] font-mono text-slate-400 pt-1 border-t border-slate-800/20">
        <span>Вместимость: {totalU}U</span>
        <span className="text-cyan-400">Позиция: {uPosition}U</span>
      </div>
    </div>
  );
};
